import * as RawData from '../data.json';

export const Data: DataElement[] = (RawData as any).default;

export interface DataElement {
    CPU?: string;
    MIPS: string;
    CLK_MHZ?: string;
    IPC_DIE?: string;
    IPC_CORE?: string;
    CORES_DIE?: string;
    YEAR: string;
    TDP?: string;
    TDP_MIPS?: string;
    BLURB?: string;
    IMAGE?: string;
};

export const DefaultDataElement: DataElement = {YEAR: '1970', MIPS: '0'};